import { fetchAuthSession } from 'aws-amplify/auth';

import { configureAmplify } from '../utils/client';

import type { AuthProps } from '../types/auth';

export const getIdTokenOnClient = async (): Promise<string | undefined> => {
  try {
    const { idToken } = (await fetchAuthSession()).tokens ?? {};

    return idToken?.toString();
  } catch {
    // No active session — fall through to undefined.
  }

  return undefined;
};

/**
 * Fetches the auth props on the client.
 * In most cases you'll want to use the `useAuthProps()` hook.
 */
export const fetchAuthPropsOnClient = async (): Promise<AuthProps> => {
  // TODO currently this does not take care of an ongoing impersonation

  await configureAmplify();

  const session = await fetchAuthSession({
    forceRefresh: false,
  });

  const idToken = session.tokens?.idToken;
  const accessToken = session.tokens?.accessToken;

  if (typeof idToken === 'undefined' || typeof accessToken === 'undefined') {
    return {
      authenticated: false,
      idToken: '',
      accessToken: '',
      impersonated: false,
    };
  }

  return {
    authenticated: !!idToken.payload.email,
    id: session.userSub,
    email: String(idToken.payload.email),
    emailVerified: idToken.payload.email_verified === true,
    idToken: idToken.toString(),
    accessToken: accessToken.toString(),
    impersonated: false,
  };
};
